import React, { FC } from 'react';
import { NotificationsWrapper } from './styled';
import { useAppSelector } from 'src/modules/shared/hooks/useAppDispatch';
import { NotificationsItem } from './Item/NotificationsItem';
import { useGetNotificationsQuery } from 'src/modules/shared/slices/comunications/notifications/notificationsApi';

export const Notifications: FC = () => {
  const selectedTab = useAppSelector((state) => state.notifications.selectedTab);
  useGetNotificationsQuery(selectedTab === 0 ? true : false);

  return (
    <NotificationsWrapper>
      <NotificationsItem />
    </NotificationsWrapper>
  );
};
